export class InvalidValueForFunding extends Error {
	constructor(name: string, value: number, method: string) {
		super(
			`Value must be equal or greater than 0. Here '${name}' is equal to '${value}' in '${method}()' method.`
		);
	}
}
